export default {
  INFO: 'TOAST_INFO',
  SUCCESS: 'TOAST_SUCCESS',
  ERROR: 'TOAST_ERROR',
  WARNING: 'TOAST_WARNING',
}
